module.exports = '<svg width="28" height="32" viewBox="0 0 28 32"><path d="M18.176 32H9.802c-1.157 0-1.809-.891-1.809-1.986V16.012H1.146c-1.157 0-1.495-.63-.755-1.469L12.648.625c.739-.843 1.943-.827 2.682.012l12.257 13.898c.739.843.402 1.477-.755 1.477h-6.847v14.002c0 1.095-.651 1.986-1.809 1.986z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/up-arrow-2.js
// module id = 1472
// module chunks = 14